const API = "/api/v1";

let csrf = "";

export function setCsrf(token: string) {
  csrf = token;
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData)) {
    headers.set("content-type", "application/json");
  }
  if (csrf && init.method && init.method !== "GET") {
    headers.set("x-csrf-token", csrf);
  }
  const res = await fetch(`${API}${path}`, {
    ...init,
    headers,
    credentials: "include",
  });
  const data = (await res.json().catch(() => ({}))) as T & { error?: { code: string; message: string } };
  if (!res.ok) {
    const err = new Error(data.error?.code || `http_${res.status}`);
    (err as Error & { status: number }).status = res.status;
    throw err;
  }
  return data;
}
